import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { ActionIconDef, GridConfig } from '@inavista/components/grid';
import { environment } from 'projects/service/src/environments/environment';

// "Cycle Count Warehouses with Open Exceptions", shown at sign-in to the roles with CycleCountsExceptionsAlert.
// Same columns, labels, link and action as the Syncfusion grid it replaces. Rows come from
// api/grid/cycle-count-open-exceptions: GetServiceManagerCycleCountsForAlerts for the employee in the login token.

const SHOWN = ['warehouse', 'technicianName', 'cycleCountId', 'startDate'];
const CENTRED = ['warehouse', 'cycleCountId'];

// The old "Open Exception" command (fa-exclamation-triangle): opens the cycle count, as the Cycle Count Id link does.
export const OPEN_EXCEPTION_ICON: ActionIconDef = {
  key: 'openException', label: 'Open Exception', colorFn: () => '#000000de',
  icon: '<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />',
};

export const CYCLE_COUNT_EXCEPTIONS_GRID_CONFIG: GridConfig = {
  apiBaseUrl: `${environment.apiUrl}grid/cycle-count-open-exceptions`,
  keyColumn: 'cycleCountId',
  defaultColumnOrder: SHOWN,
  columnLabels: {
    warehouse: 'Warehouse', technicianName: 'Technician Name', cycleCountId: 'Cycle Count Id', startDate: 'Cycle Count Date',
  },
  // RIMS grid look: headers left; text and dates left; codes and IDs centred.
  columnAlign: Object.fromEntries(SHOWN.map(c => [c, {
    header: { horizontal: 'left' as const }, ...(CENTRED.includes(c) ? { horizontal: 'center' as const } : {}),
  }])),
  columnWidths: { warehouse: 120, technicianName: 220, cycleCountId: 130, startDate: 150 },
  columnSizing: {
    warehouse: { min: 100, noStretch: true }, cycleCountId: { min: 120, noStretch: true },
    startDate: { min: 140, noStretch: true },
  },
  stretchColumns: true,
  columnDateFormats: { startDate: 'd MMM, yyyy' },
  hyperlinkColumns: ['cycleCountId'],
  excelFilterColumns: ['technicianName'],
  enableContextMenuFilter: true,
  // Excel export, as before (no role rule on this popup).
  enableExport: true,
  enableFitColumns: true,
  enableResetLayout: true,
  enableSavedViews: true,
  wrapHeaders: true,
  rowHeight: 26,
  loadingIndicator: 'banner',
  emptyStateMessage: 'No cycle count has an open exception.',
  persistenceKey: 'rims.service.cycle-count-open-exceptions',
  firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  persistenceVersion: 1,
};
